import {
  MFAActions,
  Selectors,
  useWidgetDispatch,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import envData from 'env.json';
import React from 'react';

import WebViewModal from 'components/WebViewModal';

const {API_URL, MFA_WEB_VIEW_URL} = envData;
export interface MFAWebViewProps {
  /**
   * MFA opt-in status to determine whether it's step-up or onboarding
   */
  mfaOptinStatus: boolean | undefined;
  /**
   * Gets called when webview's url changes to /rewards/* which means
   * MFA operations are completed/canceled.
   */
  onClose: () => void;
  /**
   * Show/hide modal
   */
  isModalVisible: boolean;
  /**
   * URI to load the webview with. Not needed for step-up or onboarding
   * Must be relative
   */
  uri?: string;
}

const MFAWebViewModal = (props: MFAWebViewProps) => {
  const {mfaOptinStatus, onClose, isModalVisible, uri} = props;
  const patrontoken = useWidgetState(Selectors.patrontokenSelector);
  const widgetDispatch = useWidgetDispatch();
  const optinStatus = useWidgetState(Selectors.mfaOptinStatusSelector);
  const mfaToken = useWidgetState(Selectors.mfaTokenSelector);
  const baseUrl = MFA_WEB_VIEW_URL || API_URL;

  const defaultURI = mfaOptinStatus
    ? `${baseUrl}/a/verification/step-up?webviewauth=true`
    : `${baseUrl}/a/verification?webviewauth=true`;

  const getURI = () => {
    if (uri) {
      return `${baseUrl}${uri}`;
    }
    return defaultURI;
  };

  const injectedScript = `
  (function() {
    document.cookie = "mfa_token=${mfaToken}";
    document.cookie = "patrontoken=${patrontoken}";
    window.originalConsoleLog = console.log;
    console.log = function() {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'log',
        data: Array.from(arguments)
      }));
      window.originalConsoleLog.apply(console, arguments);
    };
  })()
  true; // Note: this line is important to always return a value.
`;

  const handleWebViewMessages = event => {
    const message = JSON.parse(event.nativeEvent.data);

    if (message.type === 'log' || message.type === 'error') {
      console.log('WebView log:', ...message.data);
    }

    if (message.type === 'mfaToken') {
      widgetDispatch(MFAActions.setIsValidateTokenInitial(false));
      widgetDispatch(MFAActions.validateCodeSuccess(message.value));
    }
  };

  return (
    <WebViewModal
      onError={e => console.log('webview error:', e)}
      onHttpError={e => console.log('webview http error:', e)}
      showModal={isModalVisible}
      incognito={true}
      toggleModal={() => {}}
      uri={getURI()}
      startInLoadingState={true}
      injectedJavaScriptBeforeContentLoaded={injectedScript}
      onMessage={handleWebViewMessages}
      onNavigationStateChange={e => {
        if (e.url.includes('rewards')) {
          if (!optinStatus) {
            widgetDispatch(MFAActions.getOptinStatus());
          }
          onClose();
        }
      }}
    />
  );
};

export default MFAWebViewModal;
